export default __webpack_public_path__ + "static/media/coin 1.1171769f.svg";